import {createElement} from "react";
import {render} from "react-dom";

function errorState(formErrors, field) {
    if (formErrors && formErrors[field] !== undefined) {
        return 'has-error';
    }
    return '';
}

function loadComponents(componentsMap) {
    jQuery('[data-ui-component]').each(function() {
        const ChildName = jQuery(this).data('ui-component'); //what component
        if (componentsMap[ChildName] !== undefined) {
            let args = jQuery(this).data('args'); //any extra arguments
            const withRouter = jQuery(this).attr('router');
            if (!args) {
                args = {};
            }

            args.component = ChildName; //pass component name into args, some components (i.e. form based) might use it to identify themselves.
            if (withRouter) {
                render(
                    <Router>
                        {createElement(componentsMap[ChildName], {args:args})}
                    </Router>,
                    jQuery(this)[0]
                );
            } else {
                render(
                    createElement(componentsMap[ChildName], {args:args}),
                    jQuery(this)[0]
                );
            }
        }
    })
}

function isDark(color) {

    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'
        )
    );

    const r = color >> 16;
    const g = color >> 8 & 255;
    const b = color & 255;

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp>167.5) {
        return false;
    } else {
        return true;
    }
}

const valueFromId = (opts, id) => {
    return  opts.find(o => o.value === id);
    // const x = opts.find(o => o.value === id)
    // console.log('valueFromId', opts, id, x, typeof id);
    // return x
};

function animateScrollTo(selector, condition) {
    if (condition) {
        jQuery( 'html, body' ).animate( { scrollTop: jQuery(selector).first().offset().top - 150 } );
    }
}

/**
 * Returns true if on iOS device
 * @returns {boolean|boolean}
 */
function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function getBaseScale() {
    let scale = 10;
    if (window.innerWidth > 767) {
        scale = (window.innerWidth / 1440);
    } else if (window.innerWidth > 375 ) {
        scale = 1;
    } else { // below 375
        scale = (window.innerWidth / 375);
    }
    return scale;

}

function headerHeight($add = 0) {
    if (jQuery('body').hasClass('admin-bar')) {
        $add += 32;
    }
    return parseInt(getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height').replace('px', '')) + $add;
}

function camelCase(theString = '') {
    return theString.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
}

/**
 * Is mobile screen size
 */
function isMobile() {
    return window.innerWidth < 768;
}

/**
 * Is tablet screen size
 */
function isTablet() {
    return window.innerWidth <= 1024;
}

/**
 * Is desktop screen size
 */
function isDesktop() {
    return window.innerWidth > 1024;
}

function clog() {
    console.log(...arguments);
}

export { errorState, loadComponents , isDark, valueFromId, animateScrollTo,  iOS, getBaseScale, headerHeight, camelCase, isTablet, isMobile, isDesktop, clog };
